/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InspectionSyncItemsResponse } from './InspectionSyncItemsResponse';
import {
    InspectionSyncItemsResponseFromJSON,
    InspectionSyncItemsResponseFromJSONTyped,
    InspectionSyncItemsResponseToJSON,
    InspectionSyncItemsResponseToJSONTyped,
} from './InspectionSyncItemsResponse';

/**
 * 
 * @export
 * @interface InspectionSyncResponse
 */
export interface InspectionSyncResponse {
    /**
     * 
     * @type {Date}
     * @memberof InspectionSyncResponse
     */
    serverTimeUtc?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InspectionSyncResponse
     */
    isFullSync?: boolean;
    /**
     * 
     * @type {InspectionSyncItemsResponse}
     * @memberof InspectionSyncResponse
     */
    syncItems?: InspectionSyncItemsResponse;
}

/**
 * Check if a given object implements the InspectionSyncResponse interface.
 */
export function instanceOfInspectionSyncResponse(value: object): value is InspectionSyncResponse {
    return true;
}

export function InspectionSyncResponseFromJSON(json: any): InspectionSyncResponse {
    return InspectionSyncResponseFromJSONTyped(json, false);
}

export function InspectionSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serverTimeUtc': json['serverTimeUtc'] == null ? undefined : (new Date(json['serverTimeUtc'])),
        'isFullSync': json['isFullSync'] == null ? undefined : json['isFullSync'],
        'syncItems': json['syncItems'] == null ? undefined : InspectionSyncItemsResponseFromJSON(json['syncItems']),
    };
}

export function InspectionSyncResponseToJSON(json: any): InspectionSyncResponse {
    return InspectionSyncResponseToJSONTyped(json, false);
}

export function InspectionSyncResponseToJSONTyped(value?: InspectionSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverTimeUtc': value['serverTimeUtc'] == null ? undefined : ((value['serverTimeUtc']).toISOString()),
        'isFullSync': value['isFullSync'],
        'syncItems': InspectionSyncItemsResponseToJSON(value['syncItems']),
    };
}

